import React from "react"
import { useHistory } from "react-router"
import "./ManageCommunications.scss"

export default function ManageCommunications() {
  const history = useHistory()
  
  return (
    <div className="manage-communications-wrapper">
      <div className="heading">
        <div
          className="back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
          />
        </div>

        <div className="header-text">Manage Communications</div>
      </div>
    </div>
  )
}
